import {type CommandId, GlobalCommands} from '@github-ui/ui-commands'
import {type RefObject, useCallback, useRef, useState} from 'react'

type LazyItemPickerProps = {
  anchorElement: (props: React.HTMLAttributes<HTMLElement>, ref: RefObject<HTMLButtonElement>) => React.ReactElement
  createChild: () => React.ReactElement
  insidePortal?: boolean
  keybindingCommandId?: CommandId
}

export function LazyItemPicker({
  anchorElement,
  createChild,
  keybindingCommandId,
}: LazyItemPickerProps): React.ReactElement {
  const [wasTriggered, setWasTriggered] = useState(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  const handleKeyPress = useCallback(() => {
    if (!wasTriggered) {
      setWasTriggered(true)
    }
  }, [wasTriggered, setWasTriggered])

  if (!wasTriggered) {
    return (
      <>
        {keybindingCommandId && <GlobalCommands commands={{[keybindingCommandId]: handleKeyPress}} />}

        {anchorElement(
          {
            onClick: () => setWasTriggered(true),
            onKeyPress: (event: React.KeyboardEvent<HTMLLIElement>) => {
              // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                setWasTriggered(true)
              }
            },
          },

          anchorRef,
        )}
      </>
    )
  }

  return createChild()
}

try{ LazyItemPicker.displayName ||= 'LazyItemPicker' } catch {}